import { gql, TypedDocumentNode } from '@common/hooks';

type WorksListDueDateQueryResponse = {
  worksList: {
    id: string;
    deadlineDetails?: string;
    deadlineDueDate?: string;
    worksListTemplate?: {
      id: string;
      complianceDeadlineDetails: string;
    };
    canUpdateDeadlineDueDate: {
      value: boolean;
    };
  };
};

type WorksListDueDateQueryVariables = {
  id: string;
};

export const WorksListDueDateQuery: TypedDocumentNode<
  WorksListDueDateQueryResponse,
  WorksListDueDateQueryVariables
> = gql`
  query WorksListDueDateQuery($id: ID!) {
    worksList(id: $id) {
      id
      deadlineDetails
      deadlineDueDate
      worksListTemplate {
        id
        complianceDeadlineDetails
      }
      canUpdateDeadlineDueDate {
        value
      }
    }
  }
`;
